import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        department: '='
    },
    template: `
        <div class="heading01 type01">
            <a ui-sref="authorized.user.group.list.department()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
            <h1>{{ vm.department.value }}</h1>
        </div>
        <user-group-form-department form="vm.form" department="vm.department"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.department, model => model.$update({ id: model.id }));
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/detail/department/index.js